import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import StructuredData from '../components/StructuredData';
import contentPages from '../generated/content-pages.json';
import { getSectionI18nKey, getSectionIndexPath } from '../config/localeRoutes';
import './ArticlesList.css';

function SectionIndexPage({ section, locale = 'fr' }) {
  const { t } = useTranslation();
  const indexPath = getSectionIndexPath(section);
  const i18nKey = getSectionI18nKey(section);

  const pages = useMemo(() => {
    const entries = Object.values(contentPages[section] || {});
    const collator = new Intl.Collator(locale === 'en' ? 'en' : 'fr', { sensitivity: 'base' });
    return entries.sort((a, b) => collator.compare(a.title, b.title));
  }, [section, locale]);

  const pageMeta = {
    title: t(`${i18nKey}.title`),
    path: indexPath,
  };

  return (
    <>
      <SEO
        locale={locale}
        title={t(`${i18nKey}.seoTitle`)}
        description={t(`${i18nKey}.seoDescription`)}
        canonical={indexPath}
      />
      <StructuredData page={section} contentPage={pageMeta} locale={locale} />
      <main className="articles-list-page" id="main-content">
        <div className="articles-list-container">
          <header className="articles-list-header">
            <h1>{t(`${i18nKey}.title`)}</h1>
            <p className="articles-list-subtitle">{t(`${i18nKey}.subtitle`)}</p>
          </header>

          <ul className="articles-grid">
            {pages.map((page) => (
              <li key={page.slug}>
                <article className="article-card">
                  <h2 className="article-card-title">
                    <Link to={page.path}>{page.title}</Link>
                  </h2>
                  <p className="article-card-description">{page.description}</p>
                  <Link to={page.path} className="article-card-link">
                    {t(`${i18nKey}.readMore`)}
                    <span aria-hidden="true"> →</span>
                  </Link>
                </article>
              </li>
            ))}
          </ul>
        </div>
      </main>
    </>
  );
}

export default SectionIndexPage;
